module.exports = __webpack_public_path__ + "banquet/components/Banquet/images/banquet-og.8d065cded71a1ad0a73ab5aa6cd00100.jpg";


//////////////////
// WEBPACK FOOTER
// ./banquet/components/Banquet/images/banquet-og.jpg
// module id = 1660
// module chunks = 1